import React from 'react';
import '../styles/QuickLinks.css';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { useTranslation } from 'react-i18next';
import ScrollAnimation from './ScrollAnimation';

const QuickLinks: React.FC = () => {
    const { t } = useTranslation();

    const scrollWithOffset = (el: HTMLElement) => {
        const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;

        // Responsive offset based on screen width
        let yOffset = -120; // Default offset for larger screens

        if (window.innerWidth <= 1440) { // Laptop screens and smaller
            yOffset = -180; // Larger offset for laptop screens
        }

        if (window.innerWidth <= 768) { // Mobile screens
            yOffset = -100; // Smaller offset for mobile
        }

        window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
    };

    return (
        <div className='container'>
            <section className='main-section quickLinks'>
                <hr className='horizontal-line'></hr>
            </section>
            <ScrollAnimation animation="fadeInUp" delay={0.1}>
                <section className='main-section quickLinks-section'>
                    <div>
                        <div className='container-quickLinks'>
                            <Link to="investmentansatz?section=top"><h1>{t('investmentProducts')}</h1></Link>
                            <Link to="investmentansatz?section=products"><span>{t('productOverview')}</span></Link>
                            <Link to="investmentansatz?section=acquisition"><span>{t('acquisition')}</span></Link>
                            <Link to="investmentansatz?section=management"><span>{t('management')}</span></Link>
                        </div>
                    </div>
                    <div>
                        <div className='container-quickLinks'>
                            <HashLink to="referenzen#page-hero" scroll={scrollWithOffset}><h1>{t('projectReferences')}</h1></HashLink>
                            {/**    <HashLink smooth to="referenzen#investment-chances" scroll={scrollWithOffset}><span>{t('investmentOpportunities')}</span></HashLink>*/}
                            <HashLink to="referenzen#investment-options" scroll={scrollWithOffset}><span>{t('investmentOffers')}</span></HashLink>
                            {/**   <HashLink to="referenzen#investment-options" scroll={scrollWithOffset}><span>{t('references')}</span></HashLink> */}
                        </div>
                    </div>
                    <div>
                        <div className='container-quickLinks'>
                            <HashLink to="unternehmen#page-hero" scroll={scrollWithOffset}><h1>{t('companies')}</h1></HashLink>
                            <HashLink smooth to="unternehmen#mission" scroll={scrollWithOffset}><span>{t('mission')}</span></HashLink>
                            <HashLink to="unternehmen#brand" scroll={scrollWithOffset}><span>{t('brandCore')}</span></HashLink>
                            <HashLink to="unternehmen#network" scroll={scrollWithOffset}><span>{t('network')}</span></HashLink>
                            <HashLink to="unternehmen#team" scroll={scrollWithOffset}><span>{t('team')}</span></HashLink>
                        </div>
                    </div>
                    <div>
                        <div className='container-quickLinks'>
                            <Link to="/kontakt"><h1>{t('contact')}</h1></Link>
                        </div>
                    </div>
                </section>
            </ScrollAnimation>

        </div>
    );
};

export default QuickLinks;